// Where the signature goes in a text template.
//
// The author places a signature box anywhere in the text; it is saved as an empty
// <div data-signature-block="true"></div>. The candidate's page and the signed PDF
// put the signature where that box is, with any text after it following. A template
// with no box (older ones) simply gets the signature at the very end.

export const SIGNATURE_BLOCK_HTML = '<div data-signature-block="true"></div>';

const FIRST = /<div data-signature-block="true"><\/div>/;
const ALL = /<div data-signature-block="true"><\/div>/g;

// The text before the signature box, and the text after it (any further boxes dropped).
export function splitAtSignature(html) {
  const text = String(html ?? '');
  const match = FIRST.exec(text);
  if (!match) return { hasBox: false, before: text, after: '' };
  return {
    hasBox: true,
    before: text.slice(0, match.index),
    after: text.slice(match.index + match[0].length).replace(ALL, ''),
  };
}

// A visible stand-in for the box, for places that only preview the text (the sender's
// preview, where nobody has signed yet).
// `signer` is who signs: 'candidate' (also for placements) or 'contact'.
export const signaturePlaceholderHtml = (signer = 'candidate') =>
  '<div style="border:2px dashed #94a3b8;border-radius:6px;padding:12px 16px;margin:16px 0;color:#475569;font-size:0.9em">' +
  `<strong>Signature</strong> — the ${signer === 'contact' ? 'contact' : 'candidate'} signs here</div>`;

export const SIGNATURE_PLACEHOLDER_HTML = signaturePlaceholderHtml();

export function withSignaturePlaceholder(html, signer = 'candidate') {
  return String(html ?? '').replace(ALL, signaturePlaceholderHtml(signer));
}
